"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArticleStates;
(function (ArticleStates) {
    ArticleStates["AsNew"] = "AsNew";
    ArticleStates["Working"] = "Working";
    ArticleStates["ToBeFixed"] = "ToBeFixed";
})(ArticleStates = exports.ArticleStates || (exports.ArticleStates = {}));
var DimensionUnits;
(function (DimensionUnits) {
    DimensionUnits["cm"] = "cm";
    DimensionUnits["m"] = "m";
})(DimensionUnits = exports.DimensionUnits || (exports.DimensionUnits = {}));
;
var ColorAttributes;
(function (ColorAttributes) {
    ColorAttributes["black"] = "black";
    ColorAttributes["white"] = "white";
    ColorAttributes["grey"] = "grey";
    ColorAttributes["red"] = "red";
    ColorAttributes["pink"] = "pink";
    ColorAttributes["orange"] = "orange";
    ColorAttributes["yellow"] = "yellow";
    ColorAttributes["green"] = "green";
    ColorAttributes["blue"] = "blue";
    ColorAttributes["purple"] = "purple";
    ColorAttributes["brown"] = "brown";
    ColorAttributes["wood"] = "wood";
    ColorAttributes["transparent"] = "transparent";
    ColorAttributes["copper"] = "copper";
    ColorAttributes["silver"] = "silver";
    ColorAttributes["gold"] = "gold";
})(ColorAttributes = exports.ColorAttributes || (exports.ColorAttributes = {}));
var FurnitureLayoutAttributes;
(function (FurnitureLayoutAttributes) {
    FurnitureLayoutAttributes["drawers"] = "drawers";
    FurnitureLayoutAttributes["doors"] = "doors";
    FurnitureLayoutAttributes["slidingDoors"] = "slidingDoors";
    FurnitureLayoutAttributes["hangers"] = "hangers";
    FurnitureLayoutAttributes["shelves"] = "shelves";
})(FurnitureLayoutAttributes = exports.FurnitureLayoutAttributes || (exports.FurnitureLayoutAttributes = {}));
var CategoryNames;
(function (CategoryNames) {
    CategoryNames["table"] = "table";
    CategoryNames["storage"] = "storage";
    CategoryNames["seat"] = "seat";
    CategoryNames["sofa"] = "sofa";
    CategoryNames["bed"] = "bed";
    CategoryNames["appliances"] = "appliances";
    CategoryNames["small-appliances"] = "small-appliances";
    CategoryNames["electronics"] = "electronics";
    CategoryNames["baby"] = "baby";
    CategoryNames["decoration"] = "decoration";
    CategoryNames["lights"] = "lights";
    CategoryNames["leisure"] = "leisure";
})(CategoryNames = exports.CategoryNames || (exports.CategoryNames = {}));
var UniverseNames;
(function (UniverseNames) {
    UniverseNames["living"] = "living";
    UniverseNames["dining"] = "dining";
    UniverseNames["kitchen"] = "kitchen";
    UniverseNames["bedroom"] = "bedroom";
    UniverseNames["baby"] = "baby";
    UniverseNames["child"] = "child";
    UniverseNames["office"] = "office";
    UniverseNames["bathroom"] = "bathroom";
    UniverseNames["garden"] = "garden";
    UniverseNames["pets"] = "pets";
    UniverseNames["lobby"] = "lobby";
})(UniverseNames = exports.UniverseNames || (exports.UniverseNames = {}));
//# sourceMappingURL=index.js.map